<template>
  <!-- 劳务人员工地统计 -->
  <div class="laborers-site">
    <div class="title">
      <div class="left">劳务人员工地统计</div>
      <div class="right">
        工种统计
      </div>
    </div>
    <simple-data-count :count="allCount" name="工地总人数"/>
    <div class="pie">
      <simple-pie-circle ref="pie" :data-list="dataList" :color-list="colorList"/>
    </div>
    <div class="type-item">
      <div class="item" v-for="(item, index) in labelList" :key="index" :style="{borderColor: colorList[index % colorList.length]}">{{item.name}}</div>
<!--      <div class="item"><button @click="$refs.pie.loadEcharts">test</button></div>-->
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import SimplePieCircle from "@/components/h5/board/SimplePieCircle.vue";
import commonApi from "@/api/commonApi";
import SimpleDataCount from "@/components/h5/board/SimpleDataCount.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "EmployeeCollection",
  components: {
    SimplePieCircle, SimpleDataCount
  },
  data() {
    return {
      colorList : ["#38d7ff","#ff7621","#ffc421","#fdea43","#9eff17","#38ff6d","#4599ff","#9e66ff","#f94aff"],
      dataList: [],
      labelList: [],
      allCount: 0,
    };
  },
  created() {

  },
  mounted() {
    commonApi.contractWorkerTypeCount().then(res => {
      let arr = [];
      if (res && res.length) {
        let count = 0;
        for (let i = 0; i < res.length; i++) {
          arr.push({name: res[i].statisticName, value: res[i].statisticCount});
          count += res[i].statisticCount;
        }
        this.allCount = count;
        this.labelList = arr;
        this.dataList = arr;
        setTimeout(() => {
          this.$refs.pie.loadEcharts();
        }, 200)
      }
    });
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../components/h5/board/common";
.laborers-site{
  height: 100%;
  display: flex;
  flex-direction: column;
  .title{
    height: 30px;
  }
  .count-1{
    height: 60px;
  }
  .pie{
    flex: 1;
    overflow: hidden;
  }
  .type-item{
    .item{
      display: inline-flex;
      width: 20%;
      overflow: hidden;
      white-space: nowrap;
      border-left-width: 5px;
      border-style: solid;
      border-top: none;
      border-bottom: none;
      border-right: none;
      box-sizing: border-box;
      padding-left: 5px;
      margin-top: 10px;
    }
  }
}
.count-1{
  display: flex;
  .worker-num{
    width: 50%;
    .yq-icon-count{
      font-size: 18px;
    }
  }
  .worker-num:nth-child(2){
    text-align: right;
  }
}
</style>